<span class="dvb-kibon-betreuung-comments"
      uib-popover-template="'kibonBetreuungCommentsPopoverTemplate.html'"
      popover-title="{{vm.popoverTitle}}"
      popover-trigger="'mouseenter focus'"
      popover-placement="bottom"
      popover-append-to-body="true">
    <ng-transclude></ng-transclude>
</span>
